import React from 'react';
import './NewCardNotice.css';
import { getNewCardNotice } from '../newCardNotice';

export default function NewCardNotice({ countryCode }) {
  const { title, text } = getNewCardNotice(countryCode);
  return (
    <div className="new-card-notice" role="alert">
      <div className="new-card-notice-icon" aria-hidden>!</div>
      <div className="new-card-notice-content">
        <div className="new-card-notice-title">{title}</div>
        <div className="new-card-notice-text">{text}</div>
      </div>
    </div>
  );
}
